import { render, staticRenderFns } from "./BsContent.vue?vue&type=template&id=7fa6beb9&"
import script from "./BsContent.vue?vue&type=script&lang=js&"
export * from "./BsContent.vue?vue&type=script&lang=js&"
import style0 from "./BsContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports